export const interfaceEn = {
  'navigation.title': 'Main navigation',
  'navigation.menu': 'Menu',
  'navigation.workspace': 'Club workspace',
  'navigation.group.club': 'People & teams',
  'navigation.group.activities': 'Schedule & development',
  'navigation.group.finance': 'Finance',
  'navigation.group.administration': 'Administration',
  'navigation.home': 'Home',
  'navigation.children': 'My children',
  'pageGuide.title': 'Help with this page',
  'pageGuide.subtitle': 'Step-by-step guidance and what each action does.',
  'intro.landing': 'Choose your club to open your workspace.',
  'intro.login': 'Sign in with your club account to get started.',
  'intro.invite': 'Join your club using the invitation you received.',
  'intro.notFound': 'Use the menu to open a page you have access to.',
  'intro.overview': 'Your club at a glance. Choose a task to get started.',
  'intro.athletes': 'Find athlete records, review details and manage memberships.',
  'intro.children': 'View your linked children, add a child and request updates to their details.',
  'intro.teams': 'Organize seasons, teams, training groups and their members.',
  'intro.calendar': 'Find upcoming events. Open an event for responses and attendance.',
  'intro.training': 'Build a drill library and prepare training plans for your sessions.',
  'intro.assessments': 'Record assessments and follow athlete progress.',
  'intro.billing': 'Manage billing accounts, club fees and recorded payments.',
  'intro.payments': 'View the balances and statements of your authorized accounts.',
  'intro.competitions': 'Prepare matches, manage registrations and review playing eligibility.',
  'intro.reports': 'Find the reports available to your role.',
  'intro.settings': 'Manage club branding, member access and sign-in settings.',
  'home.tasks.title': 'Where would you like to start?',
  'home.tasks.description': 'Open a section below. Each page includes guidance when you need it.',
  'home.openSection': 'Open section',
  'home.noTasks':
    'No quick links are available for your role. Use the menu or contact your club secretary.',
  'task.athleteDetails': 'Membership & athlete profile',
  'task.guardians': 'Guardian access',
  'task.childRequests.description':
    'Ask the club to link a child to your account and follow your requests.',
  'task.inviteParent.description':
    'Invite a parent by e-mail; they add their children after signing in.',
  'task.childRequests.review.description':
    'Match the children parents asked for to athlete records and approve their access.',
  'task.guardians.description': 'Link families to athletes and review their access.',
  'task.changes': 'Review requested changes',
  'task.changes.description': 'Check updates submitted by families before approving them.',
  'task.imports.description': 'Check a file before importing records into the club.',
  'task.access.description': 'Assign roles and manage what each member can access.',
  'task.clubData.description': 'Club name, language, time zone and currency.',
  'task.billingAccounts.description':
    'Every account with its balance; open one to see its fees and payments.',
  'task.invitations.description': 'Invite members and review outstanding invitations.',
  'task.fees': 'Fee plans & monthly fees',
  'task.financeImports': 'Import finance data',
  'task.fees.description': 'Set up recurring fees and preview the monthly fee run.',
  'task.periods.description': 'Review and close financial reporting periods.',
  'task.reports.description': 'Review balances, payments and reconciliation.',
  'task.rules.description': 'Review rule versions, source verification and activation.',
  'task.matches.description': 'Open a match to select its roster and check eligibility.',
  'task.registrations.description': 'Manage athletes registered for the selected competition.',
  'task.evidence.description': 'Record and verify documents needed for participation.',
  'task.suspensions.description': 'Record and review restrictions on playing.',
  'task.history.description': 'Record verified matches played outside the club.',
  'task.drills.description': 'Create reusable exercises for your training plans.',
} as const;

export const interfaceHu: Record<keyof typeof interfaceEn, string> = {
  'navigation.title': 'Fő navigáció',
  'navigation.menu': 'Menü',
  'navigation.workspace': 'Klub munkaterülete',
  'navigation.group.club': 'Sportolók és csapatok',
  'navigation.group.activities': 'Programok és fejlődés',
  'navigation.group.finance': 'Pénzügyek',
  'navigation.group.administration': 'Adminisztráció',
  'navigation.home': 'Kezdőlap',
  'navigation.children': 'Gyermekeim',
  'pageGuide.title': 'Segítség ehhez az oldalhoz',
  'pageGuide.subtitle': 'Útmutató lépésről lépésre és a műveletek magyarázata.',
  'intro.landing': 'Válassza ki a klubját a munkaterület megnyitásához.',
  'intro.login': 'A kezdéshez jelentkezzen be a klubfiókjával.',
  'intro.invite': 'Csatlakozzon a klubhoz a kapott meghívóval.',
  'intro.notFound': 'A menüből nyisson meg egy elérhető oldalt.',
  'intro.overview': 'A klub áttekintése. A kezdéshez válasszon egy feladatot.',
  'intro.athletes': 'Keressen sportolókat, tekintse át adataikat és kezelje tagságukat.',
  'intro.children':
    'Tekintse meg a fiókjához kapcsolt gyermekeket, adjon hozzá gyermeket, és kérje adataik módosítását.',
  'intro.teams': 'Kezelje a szezonokat, csapatokat, edzéscsoportokat és tagjaikat.',
  'intro.calendar':
    'Keresse meg a következő eseményeket. Nyisson meg egy eseményt a válaszokhoz és a jelenléthez.',
  'intro.training': 'Állítson össze gyakorlatgyűjteményt és edzésterveket.',
  'intro.assessments': 'Rögzítsen felméréseket, és kövesse a sportolók fejlődését.',
  'intro.billing': 'Kezelje a fizetési számlákat, klubdíjakat és rögzített befizetéseket.',
  'intro.payments': 'Tekintse meg az engedélyezett számlák egyenlegét és kimutatásait.',
  'intro.competitions':
    'Készítse elő a mérkőzéseket, kezelje a nevezéseket és ellenőrizze a játékjogosultságot.',
  'intro.reports': 'Keresse meg a szerepköréhez elérhető jelentéseket.',
  'intro.settings':
    'Kezelje a klub arculatát, a tagok hozzáférését és a bejelentkezési beállításokat.',
  'home.tasks.title': 'Mivel szeretne kezdeni?',
  'home.tasks.description':
    'Nyisson meg egy területet. Minden oldalon talál segítséget, ha szüksége van rá.',
  'home.openSection': 'Terület megnyitása',
  'home.noTasks':
    'Ehhez a szerepkörhöz nincs gyorshivatkozás. Használja a menüt, vagy forduljon a klub titkárához.',
  'task.athleteDetails': 'Tagság és sportolói profil',
  'task.guardians': 'Gondviselői hozzáférés',
  'task.childRequests.description':
    'Kérje gyermeke hozzákapcsolását a fiókjához, és kövesse a kérelmeit.',
  'task.inviteParent.description':
    'Hívjon meg egy szülőt e-mailben; a bejelentkezés után ő adja hozzá a gyermekeit.',
  'task.childRequests.review.description':
    'Párosítsa a szülők által kért gyermekeket a sportolói adatlapokkal, és hagyja jóvá a hozzáférést.',
  'task.guardians.description':
    'Kapcsolja a családokat a sportolókhoz, és tekintse át hozzáférésüket.',
  'task.changes': 'Módosítási kérelmek áttekintése',
  'task.changes.description': 'Jóváhagyás előtt ellenőrizze a családok által kért módosításokat.',
  'task.imports.description': 'Ellenőrizze a fájlt, mielőtt adatokat importál a klubba.',
  'task.access.description': 'Osszon ki szerepköröket, és kezelje a tagok jogosultságait.',
  'task.clubData.description': 'A klub neve, nyelve, időzónája és pénzneme.',
  'task.billingAccounts.description':
    'Minden fiók az egyenlegével; nyisson meg egyet a díjai és befizetései megtekintéséhez.',
  'task.invitations.description': 'Hívjon meg tagokat, és tekintse át a függő meghívókat.',
  'task.fees': 'Díjtervek és havi díjak',
  'task.financeImports': 'Pénzügyi adatok importálása',
  'task.fees.description':
    'Állítsa be az ismétlődő díjakat, és tekintse át a havi díjfuttatás előnézetét.',
  'task.periods.description': 'Tekintse át és zárja le a pénzügyi időszakokat.',
  'task.reports.description': 'Tekintse át az egyenlegeket, befizetéseket és az egyeztetést.',
  'task.rules.description': 'Tekintse át a szabályverziókat, a forrásellenőrzést és az aktiválást.',
  'task.matches.description':
    'Nyisson meg egy mérkőzést a keret kiválasztásához és a jogosultság ellenőrzéséhez.',
  'task.registrations.description': 'Kezelje a kiválasztott versenyre nevezett sportolókat.',
  'task.evidence.description': 'Rögzítse és ellenőrizze a részvételhez szükséges dokumentumokat.',
  'task.suspensions.description': 'Rögzítse és tekintse át a játék korlátozásait.',
  'task.history.description': 'Rögzítse a klubon kívül játszott, igazolt mérkőzéseket.',
  'task.drills.description': 'Készítsen újra felhasználható gyakorlatokat az edzéstervekhez.',
};

export const interfaceRo: Record<keyof typeof interfaceEn, string> = {
  'navigation.title': 'Navigare principală',
  'navigation.menu': 'Meniu',
  'navigation.workspace': 'Spațiul clubului',
  'navigation.group.club': 'Sportivi și echipe',
  'navigation.group.activities': 'Program și dezvoltare',
  'navigation.group.finance': 'Finanțe',
  'navigation.group.administration': 'Administrare',
  'navigation.home': 'Acasă',
  'navigation.children': 'Copiii mei',
  'pageGuide.title': 'Ajutor pentru această pagină',
  'pageGuide.subtitle': 'Ghid pas cu pas și explicații pentru fiecare acțiune.',
  'intro.landing': 'Alegeți clubul pentru a deschide spațiul de lucru.',
  'intro.login': 'Autentificați-vă cu contul clubului pentru a începe.',
  'intro.invite': 'Alăturați-vă clubului folosind invitația primită.',
  'intro.notFound': 'Folosiți meniul pentru a deschide o pagină la care aveți acces.',
  'intro.overview': 'Clubul dintr-o privire. Alegeți o activitate pentru a începe.',
  'intro.athletes':
    'Găsiți fișele sportivilor, verificați datele și gestionați apartenența la club.',
  'intro.children':
    'Vedeți copiii asociați contului, adăugați un copil și solicitați actualizarea datelor lor.',
  'intro.teams': 'Organizați sezoanele, echipele, grupele de antrenament și membrii lor.',
  'intro.calendar':
    'Găsiți evenimentele următoare. Deschideți un eveniment pentru răspunsuri și prezență.',
  'intro.training': 'Creați o bibliotecă de exerciții și pregătiți planuri de antrenament.',
  'intro.assessments': 'Înregistrați evaluări și urmăriți progresul sportivilor.',
  'intro.billing': 'Gestionați conturile de plată, taxele clubului și plățile înregistrate.',
  'intro.payments': 'Vedeți soldurile și extrasele conturilor pentru care aveți acces.',
  'intro.competitions':
    'Pregătiți meciurile, gestionați înscrierile și verificați eligibilitatea de joc.',
  'intro.reports': 'Găsiți rapoartele disponibile pentru rolul dvs.',
  'intro.settings':
    'Gestionați identitatea vizuală, accesul membrilor și setările de autentificare.',
  'home.tasks.title': 'Cu ce doriți să începeți?',
  'home.tasks.description':
    'Deschideți o secțiune. Fiecare pagină include îndrumări când aveți nevoie.',
  'home.openSection': 'Deschide secțiunea',
  'home.noTasks':
    'Nu sunt disponibile legături rapide pentru rolul dvs. Folosiți meniul sau contactați secretarul clubului.',
  'task.athleteDetails': 'Apartenență și profil sportiv',
  'task.guardians': 'Accesul tutorilor',
  'task.childRequests.description':
    'Solicitați asocierea unui copil cu contul dumneavoastră și urmăriți cererile.',
  'task.inviteParent.description':
    'Invitați un părinte prin e-mail; după autentificare, acesta își adaugă copiii.',
  'task.childRequests.review.description':
    'Asociați copiii solicitați de părinți cu fișele sportivilor și aprobați accesul.',
  'task.guardians.description': 'Asociați familiile cu sportivii și verificați accesul lor.',
  'task.changes': 'Verifică modificările solicitate',
  'task.changes.description': 'Verificați actualizările trimise de familii înainte de aprobare.',
  'task.imports.description': 'Verificați un fișier înainte de a importa date în club.',
  'task.access.description': 'Atribuiți roluri și gestionați accesul fiecărui membru.',
  'task.clubData.description': 'Numele clubului, limba, fusul orar și moneda.',
  'task.billingAccounts.description':
    'Toate conturile cu soldul lor; deschideți unul pentru a vedea taxele și plățile.',
  'task.invitations.description': 'Invitați membri și verificați invitațiile în așteptare.',
  'task.fees': 'Planuri de taxe și taxe lunare',
  'task.financeImports': 'Importă date financiare',
  'task.fees.description': 'Configurați taxele recurente și previzualizați generarea lunară.',
  'task.periods.description': 'Verificați și închideți perioadele de raportare financiară.',
  'task.reports.description': 'Verificați soldurile, plățile și reconcilierea.',
  'task.rules.description': 'Verificați versiunile regulilor, sursele și activarea.',
  'task.matches.description':
    'Deschideți un meci pentru a selecta lotul și a verifica eligibilitatea.',
  'task.registrations.description': 'Gestionați sportivii înscriși la competiția selectată.',
  'task.evidence.description': 'Înregistrați și verificați documentele necesare participării.',
  'task.suspensions.description': 'Înregistrați și verificați restricțiile de joc.',
  'task.history.description': 'Înregistrați meciurile verificate jucate în afara clubului.',
  'task.drills.description': 'Creați exerciții reutilizabile pentru planurile de antrenament.',
};
